<template>
  <div class="container-page big">
    <h2 class="title title--h2">
      {{ isSC ? 'Карточка подкомиссии' : isRG ? 'Карточка РГ' : 'Карточка МПК' }}
    </h2>

    <Tab class="tab-redesign">
      <TabItem name="Основная информация" :selected="true">
        <!-- формы для создания -->
        <form action="/" class="form-card" v-if="isRG || isSC">
          <div class="coll coll-12" v-if="!isEdit">
            <h3 class="title title--h3 title--commission">Место и название</h3>
          </div>
          <div class="coll coll-inner coll-12">
            <div class="coll coll-inner coll-6 coll-t-12">
              <div v-if="!isEdit && !isReadonly" class="coll coll-12 m-24">
                <div class="label-field">Страна <span>*</span></div>
                <SelectMultiComponent
                  v-model="item.countryId"
                  :options="countryList"
                  placeholder="Выберите"
                  modifier="rectangular"
                  @select="changeCountry"
                  required
                  :isError="errorCountryId"
                />
              </div>
              <div class="coll coll-12 m-24" v-if="isEdit || isReadonly">
                <div class="label-field">Страна <span>*</span></div>
                <div class="form-card__country">
                  <div
                    class="form-card__country-img"
                    v-if="item.country?.picture"
                    :style="{ 'background-image': `url(${item.country?.picture})` }"
                  ></div>
                  {{ item.country?.name }}
                </div>
              </div>
              <div class="coll coll-12 m-24">
                <ComponentInput
                  :label="isSC ? 'Полное название подкомиссии <span>*</span>' : 'Полное название РГ <span>*</span>'"
                  v-model="item.name"
                  required
                  :maxLength="500"
                  type="textarea"
                  placeholder="Введите"
                  mod="rectangular"
                  :disabled="isReadonly"
                />
              </div>
              <div class="coll coll-12 m-24">
                <div class="label-field">Статус <span>*</span></div>
                <SelectMultiComponent
                  v-model="item.statusId"
                  :options="statusList"
                  placeholder="Выберите"
                  modifier="rectangular"
                  :disabled="isReadonly"
                  required
                />
              </div>
              <div class="coll coll-12 m-24" v-if="!isEdit && !isReadonly">
                <div v-if="isRG" class="label-field">Межправительственная комиссия / подкомиссия <span>*</span></div>
                <div v-if="isSC" class="label-field">Межправительственная комиссия <span>*</span></div>
                <SelectMultiComponent
                  v-model="item.parentId"
                  :options="parentList"
                  placeholder="Выберите"
                  modifier="rectangular"
                  :disabled="isReadonly"
                  required
                  :isError="errorParentId"
                />
              </div>
              <div class="coll coll-12 m-24" v-if="isEdit || isReadonly">
                <div v-if="isRG" class="label-field">Межправительственная комиссия / подкомиссия <span>*</span></div>
                <div v-if="isSC" class="label-field">Межправительственная комиссия <span>*</span></div>
                <p class="form-card__parent">{{ item.parentName }}</p>
              </div>
              <div class="coll coll-12 m-24">
                <div class="label-field">ФОИВ куратора</div>
                <SelectMultiComponent
                  v-model="item.foivCuratorId"
                  :options="foivList"
                  placeholder="Выберите"
                  modifier="rectangular"
                  :disabled="isReadonly"
                />
              </div>
            </div>
          </div>
          <div class="coll coll-12 m-24" v-if="item.countryId > 0">
            <h3 class="title title--h3 title--commission">Участники</h3>
          </div>
          <div class="form-card__inner-card" v-if="item.countryId > 0">
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="chairman"
                :isReadonly="isReadonly"
                :participantCategoryId="1"
                :commissionType="isRG ? 'РГ' : isSC ? 'подкомиссии' : 'МПК'"
                :participantCategoryName="getParticipantCategoryName(1)"
                :countryId="countryRussiaId"
                :countryName="countryRussiaName"
              />
            </div>
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="chairmanForeign"
                :isReadonly="isReadonly"
                :participantCategoryId="1"
                :commissionType="isRG ? 'РГ' : isSC ? 'подкомиссии' : 'МПК'"
                :participantCategoryName="getParticipantCategoryName(1)"
                :countryId="item.countryId"
                :countryName="getCountryName(item.countryId)"
              />
            </div>
          </div>

          <div class="coll coll-12 m-24" v-if="eventsFull.length || isEdit">
            <h3 class="title title--h3 title--commission">Мероприятия</h3>
          </div>
          <CommissionEventsHistory
            v-if="eventsFull.length"
            :eventsFull="eventsFull"
            :getEvent="getEvent"
            :showFullListEvent="showFullListEvent"
            @editEvent="editEvent"
            @toggleEvents="showEvent"
          />

          <div v-if="isEdit && !isReadonly" class="coll coll-12">
            <div>
              <ButtonComponent
                @click.prevent.stop="createEvent"
                mod="gradient-bg"
                class="button-redesign--map-apply button-redesign--commission-form-edit create-event--button"
                >Создать мероприятие</ButtonComponent
              >
            </div>

            <ButtonComponent
              @click.prevent.stop="save"
              mod="gradient-bg"
              class="button-redesign--map-apply button-redesign--commission-form-edit"
              >Сохранить</ButtonComponent
            >
            <ButtonComponent @click.prevent.stop="close" class="button-redesign--commission-form-edit"
              >Отменить</ButtonComponent
            >
          </div>

          <div v-if="!isEdit && !isReadonly" class="coll coll-inner coll-12">
            <div class="coll coll-inner coll-6 coll-m-12">
              <div class="coll coll-6 coll-m-12 m-24">
                <ButtonComponent
                  @click.prevent.stop="save"
                  mod="gradient-bg"
                  class="button-redesign--map-apply button-redesign--commission-form"
                  >Сохранить</ButtonComponent
                >
              </div>
              <div class="coll coll-6 coll-m-12 m-24">
                <ButtonComponent @click.prevent.stop="close" class="button-redesign--commission-form"
                  >Отменить</ButtonComponent
                >
              </div>
            </div>
          </div>
        </form>

        <form action="/" class="form-card" v-else>
          <div class="coll coll-12 m-24" v-if="!isEdit">
            <h3 class="title title--h3 title--commission">Место и название</h3>
          </div>
          <div class="coll coll-inner coll-12">
            <div class="coll coll-inner coll-6 coll-t-12">
              <div class="coll coll-12 m-24" v-if="!isEdit && !isReadonly">
                <div class="label-field">Страна <span>*</span></div>
                <SelectMultiComponent
                  v-model="item.countryId"
                  :options="countryList"
                  placeholder="Выберите"
                  modifier="rectangular"
                  @select="changeCountry"
                  required
                />
              </div>
              <div class="coll coll-12 m-24" v-if="isEdit || isReadonly">
                <div class="label-field">Страна <span>*</span></div>
                <div class="form-card__country">
                  <div
                    class="form-card__country-img"
                    v-if="item.country?.picture"
                    :style="{ 'background-image': `url(${item.country?.picture})` }"
                  ></div>
                  {{ item.country?.name }}
                </div>
              </div>
              <template v-if="!isEdit && !isReadonly">
                <div class="coll coll-12 m-24">
                  <DateComponent
                    label="Дата создания"
                    v-model="item.createdInfo"
                    modPicker="rectangular"
                    :clearable="false"
                    :dateIcon="true"
                    modClass="modal-request"
                    :disabled="isReadonly"
                  />
                </div>
                <div class="coll coll-12 m-24">
                  <div class="label-field">Статус <span>*</span></div>
                  <SelectMultiComponent
                    v-model="item.statusId"
                    :options="statusList"
                    placeholder="Выберите"
                    modifier="rectangular"
                    required
                  />
                </div>
                <div class="coll coll-12 m-24">
                  <ComponentInput
                    label="Полное название комиссии <span>*</span>"
                    v-model="item.name"
                    required
                    :maxLength="500"
                    type="textarea"
                    placeholder="Введите"
                    mod="rectangular"
                  />
                </div>
              </template>
              <template v-else>
                <div class="coll coll-12 m-24">
                  <DateComponent
                    label="Дата создания"
                    v-model="item.createdInfo"
                    modPicker="rectangular"
                    :clearable="false"
                    :dateIcon="true"
                    modClass="modal-request"
                    :disabled="isReadonly"
                  />
                </div>
                <div class="coll coll-12 m-24">
                  <div class="label-field">Статус <span>*</span></div>
                  <SelectMultiComponent
                    v-model="item.statusId"
                    :options="statusList"
                    placeholder="Выберите"
                    modifier="rectangular"
                    required
                    :disabled="isReadonly"
                  />
                </div>
                <div class="coll coll-12 m-24">
                  <ComponentInput
                    label="Полное название комиссии <span>*</span>"
                    v-model="item.name"
                    required
                    :maxLength="500"
                    type="textarea"
                    placeholder="Введите"
                    mod="rectangular"
                    :disabled="isReadonly"
                  />
                </div>
              </template>
            </div>
          </div>

          <div class="coll coll-12 m-24" v-if="item.countryId > 0">
            <h3 class="title title--h3 title--commission">Участники</h3>
          </div>
          <div class="form-card__inner-card" v-if="item.countryId > 0">
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="chairman"
                :isReadonly="isReadonly"
                :participantCategoryId="1"
                :commissionType="isRG ? 'РГ' : isSC ? 'подкомиссии' : 'МПК'"
                :participantCategoryName="getParticipantCategoryName(1)"
                :countryId="countryRussiaId"
                :countryName="countryRussiaName"
              />
            </div>
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="chairmanForeign"
                :isReadonly="isReadonly"
                :participantCategoryId="1"
                :commissionType="isRG ? 'РГ' : isSC ? 'подкомиссии' : 'МПК'"
                :participantCategoryName="getParticipantCategoryName(1)"
                :countryId="item.countryId"
                :countryName="getCountryName(item.countryId)"
              />
            </div>
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="coChairman"
                :isReadonly="isReadonly"
                :participantCategoryId="2"
                :participantCategoryName="getParticipantCategoryName(2)"
                :countryId="countryRussiaId"
                :countryName="countryRussiaName"
              />
            </div>
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="coChairmanForeign"
                :isReadonly="isReadonly"
                :participantCategoryId="2"
                :participantCategoryName="getParticipantCategoryName(2)"
                :countryId="item.countryId"
                :countryName="getCountryName(item.countryId)"
              />
            </div>
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="secretary"
                :isReadonly="isReadonly"
                :participantCategoryId="3"
                :participantCategoryName="getParticipantCategoryName(3)"
                :countryId="countryRussiaId"
                :countryName="countryRussiaName"
              />
            </div>
            <div class="coll coll-6 coll-t-12 m-24">
              <CommissionParticipantBlock
                v-model="secretaryForeign"
                :isReadonly="isReadonly"
                :participantCategoryId="3"
                :participantCategoryName="getParticipantCategoryName(3)"
                :countryId="item.countryId"
                :countryName="getCountryName(item.countryId)"
              />
            </div>
          </div>

          <div class="coll coll-12 m-24" v-if="eventsFull.length || (isEdit && !isReadonly)">
            <h3 class="title title--h3 title--commission">Мероприятия</h3>
          </div>
          <CommissionEventsHistory
            v-if="eventsFull.length"
            :eventsFull="eventsFull"
            :getEvent="getEvent"
            :showFullListEvent="showFullListEvent"
            @editEvent="editEvent"
            @toggleEvents="showEvent"
          />

          <div v-if="isEdit && !isReadonly" class="coll coll-12">
            <ButtonComponent
              @click.prevent.stop="createEvent"
              mod="gradient-bg"
              class="button-redesign--map-apply button-redesign--commission-form-edit create-event--button"
              >Создать мероприятие</ButtonComponent
            >
            <div>
              <ButtonComponent
                @click.prevent.stop="save"
                mod="gradient-bg"
                class="button-redesign--map-apply button-redesign--commission-form-edit"
                >Сохранить</ButtonComponent
              >
              <ButtonComponent @click.prevent.stop="close" class="button-redesign--commission-form-edit"
                >Отменить</ButtonComponent
              >
            </div>
          </div>

          <div v-if="!isEdit && !isReadonly" class="coll coll-inner coll-12">
            <div class="coll coll-inner coll-6 coll-m-12">
              <div class="coll coll-6 coll-m-12 m-24">
                <ButtonComponent
                  @click.prevent.stop="save"
                  mod="gradient-bg"
                  class="button-redesign--map-apply button-redesign--commission-form"
                  >Сохранить</ButtonComponent
                >
              </div>
              <div class="coll coll-6 coll-m-12 m-24">
                <ButtonComponent @click.prevent.stop="close" class="button-redesign--commission-form"
                  >Отменить</ButtonComponent
                >
              </div>
            </div>
          </div>
        </form>
      </TabItem>
      <TabItem v-if="id > 0 && !isRG" name="Структура">
        <div class="commision-mpk__container">
          <div class="commision-mpk__table table-container js-table-arrow">
            <table class="stockTable">
              <thead>
                <tr>
                  <th>{{ isSC ? 'Полное наименование' : 'Полное название' }}</th>
                  <th>Страна</th>
                  <th>Руководитель Российской части</th>
                  <th>Руководитель иностранной части</th>
                  <th>Последнее&nbsp;заседание</th>
                  <th v-if="canEdit"></th>
                  <th v-if="canEdit"></th>
                </tr>
              </thead>
              <TableBody :itemsBody="structuredRgItems" :isLoading="false" :showStubs="false">
                <tr
                  v-for="item in structuredRgItems"
                  :key="item.id"
                  @click="editRg(item)"
                  :class="['structure-row', `structure-row_level-${item.structureLevel}`]"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.country.name }}</td>
                  <td>
                    <template v-if="item.chairman">
                      <span class="name">{{ item.chairman.name }}</span>
                      {{ item.chairman.position }}
                    </template>
                    <template v-else> (уточняется) </template>
                  </td>
                  <td>
                    <template v-if="item.chairmanForeign">
                      <span class="name">{{ item.chairmanForeign.name }}</span>
                      {{ item.chairmanForeign.position }}
                    </template>
                    <template v-else> (уточняется) </template>
                  </td>
                  <td>
                    <template v-if="item.lastEventZased">
                      <span class="date">{{
                        $momentFormat(item.lastEventZased.eventFirstDate, Constants.DATE_FORMATS.DD_MMMM_YYYY)
                      }}</span>
                      {{ item.lastEventZased.place }}
                    </template>
                    <template v-else> (уточняется) </template>
                  </td>
                  <td v-if="canEdit">
                    <IconComponent @click.prevent.stop="editRg(item)" name="mode" />
                  </td>
                  <td v-if="canEdit">
                    <IconComponent @click.prevent.stop="deleteRg(item.id)" name="delete" />
                  </td>
                </tr>
              </TableBody>
            </table>
          </div>
        </div>
      </TabItem>
      <TabItem name="Документы">
        <form action="/" class="form-card">
          <div class="coll coll-12 m-24">
            <h3 class="title title--h3 title--commission">Документы</h3>
          </div>
          <div class="coll coll-inner coll-12">
            <div class="coll coll-inner coll-6 coll-t-12">
              <div class="coll coll-12">
                <FileMultiUpload
                  :entity="item"
                  @deleteFile="removeFile"
                  propName="files"
                  @uploaded="fileUploaded"
                  :readonly="isReadonly"
                />
              </div>
            </div>
          </div>
          <div class="coll coll-inner coll-12">
            <div class="coll coll-inner coll-6 coll-m-12">
              <div class="coll coll-6 coll-m-12 m-24">
                <ButtonComponent
                  @click.prevent.stop="save"
                  mod="gradient-bg"
                  class="button-redesign--map-apply button-redesign--commission-form"
                  >Сохранить</ButtonComponent
                >
              </div>
              <div class="coll coll-6 coll-m-12 m-24">
                <ButtonComponent @click.prevent.stop="close" class="button-redesign--commission-form"
                  >Отменить</ButtonComponent
                >
              </div>
            </div>
          </div>
        </form>
      </TabItem>
    </Tab>
    <ModalComponent title="Создание мероприятия" @close="closeEventModal" v-model="showEventModal" width="1000px">
      <EventCardAddContent
        v-if="isEventCreating"
        :key="eventModalNn"
        :isCountryDisabled="true"
        :isMpkDisabled="true"
        :initialCountryId="item.countryId"
        :initialMpkId="item.id"
        @saved="onEventSaved"
        @cancel="closeEventModal"
      />
    </ModalComponent>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';
  import { required, requiredIf } from '@vuelidate/validators';
  import moment from 'moment';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import FileMultiUpload from '@/common/components/FileMultiUpload.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import TableBody from '@/common/components/redesigned/TableBody.vue';
  import Tab from '@/common/components/redesigned/Tabs/Tab.vue';
  import TabItem from '@/common/components/redesigned/Tabs/TabItem.vue';
  import SelectMultiComponent from '@/common/components/SelectMultiComponent.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import Utils from '@/common/utils';

  import ModalComponent from '@/components/modals/ModalComponent.vue';

  import API_ORG from '@/modules/admin/api/organization';
  import CommissionEventsHistory from '@/modules/mpk/components/CommissionEventsHistory.vue';
  import EventCardAddContent from '@/modules/mpk/components/EventCardAddContent.vue';
  import { COMMISSION_TYPE_IDS, COMMISSION_TYPE_IDS_REVERSE, COMMISSION_TYPE_MAP } from '@/modules/mpk/utils/constants';

  import API from '../api/commission';
  import CommissionParticipantBlock from '../components/CommissionParticipantBlock.vue';

  const selectValidator = (value) => value > 0;
  const selectIfRGValidator = (param) => (value) => {
    return !param || value > 0;
  };

  const TYPE_EVENT_ID_MEETINGS_MPK = 1;
  const TYPE_EVENT_ID_MEETINGS_CO_CHAIRS = 3;

  const PERMISSIONS = {
    view: Constants.Permissions.MpkCommissionAccess,
    create: Constants.Permissions.MpkCommissionCreate,
    edit: Constants.Permissions.MpkCommissionEdit,
  };

  export default {
    name: 'CommissionCard',
    components: {
      ComponentInput,
      CommissionParticipantBlock,
      FileMultiUpload,
      IconComponent,
      TabItem,
      Tab,
      SelectMultiComponent,
      ButtonComponent,
      DateComponent,
      CommissionEventsHistory,
      ModalComponent,
      EventCardAddContent,
      TableBody,
    },
    mixins: [security],
    data() {
      return {
        id: this.$route.params.id,
        isReadonly: this.$route.params.action === 'view',
        isEdit: this.$route.params.action === 'edit',

        isRG: this.$route.params.type === COMMISSION_TYPE_MAP.rg,
        isSC: this.$route.params.type === COMMISSION_TYPE_MAP.sc,
        type: COMMISSION_TYPE_MAP[this.$route.params.type],

        canEdit: false,
        item: {
          countryId: 0,
          foivCuratorId: null,
          statusId: '',
          parentId: '',
        },
        chairman: null,
        chairmanForeign: null,
        coChairman: null,
        coChairmanForeign: null,
        secretary: null,
        secretaryForeign: null,
        Constants: Constants,

        countryRussiaName: Constants.countryRussiaName,
        countryRussiaId: Constants.countryRussiaId,
        countryList: [],
        parentList: [],
        participantCategoryList: [],
        foivList: [],
        statusList: [],

        pageRg: { items: [] },
        events: [],
        eventsFull: [],

        errorCountryId: false,
        errorStatusId: false,
        errorParentId: false,
        // eventsList: [],
        showFullListEvent: false,
        showEventModal: false,
        eventModalNn: 1,
        isEventCreating: false,
      };
    },
    async created() {
      const action = this.$route.params.action;
      let permission = PERMISSIONS.view;

      if (action === 'create') {
        permission = PERMISSIONS.create;
      } else if (action === 'edit') {
        permission = PERMISSIONS.edit;
      }

      const isAllowed = await this.checkPermissionAndRedirect(permission);
      if (!isAllowed) return;

      if (action === 'view') {
        this.isReadonly = true;
      }

      this.checkPermission(PERMISSIONS.edit).then((response) => {
        this.canEdit = response.data;
      });

      this.loadCard();

      Utils.loadMultiSelectOptions('countryList', this.countryList, { exceptId: this.countryRussiaId });
      Utils.loadMultiSelectOptions('mpkParticipantCategoryList', this.participantCategoryList);
      Utils.loadMultiSelectOptions('mpkStatusList', this.statusList);

      if (this.isRG || this.isSC) {
        API_ORG.searchShortFormat({ pageNumber: 1, pageSize: 0, filter: { typeIds: ['1'] } }).then((res) => {
          this.foivList = res.data.items.map((x) => ({ value: x.id, label: x.name }));
        });
      }
    },
    computed: {
      countryId() {
        return this.item.countryId;
      },
      statusId() {
        return this.item.statusId;
      },
      parentId() {
        return this.item.parentId;
      },

      getEvent() {
        if (this.showFullListEvent) {
          return this.eventsFull;
        }
        return this.events;
      },
      structuredRgItems() {
        const sourceItems = this.pageRg.items;
        const currentRootId = this.item?.id;
        const nodesByIdMap = new Map();

        for (const commissionItem of sourceItems) {
          nodesByIdMap.set(commissionItem.id, { data: commissionItem, children: [] });
        }

        const rootNodeList = [];
        for (const commissionItem of sourceItems) {
          const currentNode = nodesByIdMap.get(commissionItem.id);
          const parentIdentifier = commissionItem.parentId;

          if (parentIdentifier === currentRootId || !nodesByIdMap.has(parentIdentifier)) {
            rootNodeList.push(currentNode);
            continue;
          }

          const parentNode = nodesByIdMap.get(parentIdentifier);
          parentNode.children.push(currentNode);
        }
        return this.flattenTree(rootNodeList, 0);
      },
    },
    watch: {
      countryId() {
        this.errorCountryId = false;
      },
      statusId() {
        this.errorStatusId = false;
      },
      parentId() {
        this.errorParentId = false;
      },
    },
    methods: {
      loadPageRg() {
        if (this.isRG || this.item.id <= 0) return;
        var params = {
          pageNumber: 1,
          pageSize: 0,
          hasParent: true,
          parentId: this.item.id,
        };

        API.search(params).then((response) => {
          this.pageRg = response.data;
        });
      },
      flattenTree(nodes, depthLevel) {
        const flattenedResult = [];
        const traversalStack = [];
        for (let index = nodes.length - 1; index >= 0; index--) {
          traversalStack.push({ node: nodes[index], depth: depthLevel });
        }
        while (traversalStack.length > 0) {
          const stackItem = traversalStack.pop();
          flattenedResult.push({ ...stackItem.node.data, structureLevel: stackItem.depth });
          const childrenList = stackItem.node.children;
          for (let index = childrenList.length - 1; index >= 0; index--) {
            traversalStack.push({ node: childrenList[index], depth: stackItem.depth + 1 });
          }
        }
        return flattenedResult;
      },
      getParticipantCategoryName(id) {
        if (!(this.participantCategoryList.length > 0)) return '';
        var el = this.participantCategoryList.find((x) => +x.value === +id);
        if ((this.isRG || this.isSC) && id == 1) return 'Руководитель';
        return el ? el.label : '';
      },
      getCountryName(id) {
        if (!(this.countryList.length > 0)) return '';
        var el = this.countryList.find((x) => x.id == id);
        return el ? el.text : '';
      },
      async changeCountry() {
        this.chairmanForeign = null;
        this.coChairmanForeign = null;
        this.secretaryForeign = null;

        //parentList
        if (this.isRG || this.isSC) {
          this.parentList = [];
          this.item.parentId = 0;

          const types = this.isRG
            ? [COMMISSION_TYPE_IDS_REVERSE.mp, COMMISSION_TYPE_IDS_REVERSE.sc]
            : [COMMISSION_TYPE_IDS_REVERSE.mp];

          try {
            const response = await API.searchForList({
              countryId: this.item.countryId,
              types,
            });

            if (response.data?.items) {
              this.parentList = response.data.items.map((x) => ({ value: x.id, label: x.name }));
            }
          } catch (error) {
            console.error(error);
          }
        }
      },
      loadCard() {
        if (this.id > 0) {
          API.find(this.id).then((response) => {
            this.item = response.data;

            if (response.data?.status?.id) {
              this.item.statusId = response.data?.status.id;
            }
            if (response.data?.createdInfo || response.data?.created) {
              this.item.createdInfo = response.data?.createdInfo || response.data?.created || '';
            }
            this.chairman = this.item.mpkParticipants.find(
              (x) => x.participant.participantCategoryId == 1 && x.participant.countryId == this.countryRussiaId,
            );
            this.chairmanForeign = this.item.mpkParticipants.find(
              (x) => x.participant.participantCategoryId == 1 && x.participant.countryId != this.countryRussiaId,
            );
            this.coChairman = this.item.mpkParticipants.find(
              (x) => x.participant.participantCategoryId == 2 && x.participant.countryId == this.countryRussiaId,
            );
            this.coChairmanForeign = this.item.mpkParticipants.find(
              (x) => x.participant.participantCategoryId == 2 && x.participant.countryId != this.countryRussiaId,
            );
            this.secretary = this.item.mpkParticipants.find(
              (x) => x.participant.participantCategoryId == 3 && x.participant.countryId == this.countryRussiaId,
            );
            this.secretaryForeign = this.item.mpkParticipants.find(
              (x) => x.participant.participantCategoryId == 3 && x.participant.countryId != this.countryRussiaId,
            );

            if (this.chairman) this.chairman = this.chairman.participant;
            if (this.chairmanForeign) this.chairmanForeign = this.chairmanForeign.participant;
            if (this.coChairman) this.coChairman = this.coChairman.participant;
            if (this.coChairmanForeign) this.coChairmanForeign = this.coChairmanForeign.participant;
            if (this.secretary) this.secretary = this.secretary.participant;
            if (this.secretaryForeign) this.secretaryForeign = this.secretaryForeign.participant;

            if (!this.isRG) this.loadPageRg();

            this.processEvents(this.item.events);
          });
        } else {
          this.item = {
            isActive: true,
            countryId: 0,
            mpkParticipants: [],
            parentId: this.isRG || this.isSC ? 0 : null,
            files: [],
          };

          if (this.$route.query && this.$route.query.countryId > 0) this.item.countryId = this.$route.query.countryId;
        }
      },
      save() {
        if (this.isReadonly) return;

        this.v$.$touch();
        if (this.v$.item.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');

          if (!this.countryId) {
            this.errorCountryId = true;
          }
          if (!this.statusId) {
            this.errorStatusId = true;
          }

          if ((this.isRG || this.isSC) && !this.parentId) {
            this.errorParentId = true;
          }
          return;
        }

        var itemToSave = Object.assign({}, this.item);
        itemToSave.participants = [
          this.chairman,
          this.chairmanForeign,
          this.coChairman,
          this.coChairmanForeign,
          this.secretary,
          this.secretaryForeign,
        ];

        itemToSave.mpkCommissionDocumentIds = itemToSave.files.map((x) => x.id);
        itemToSave.files = null;
        itemToSave.events = null;
        itemToSave.mpkParticipants = null;
        (itemToSave.type = COMMISSION_TYPE_IDS_REVERSE[this.type]),
          API.update(itemToSave)
            .then((response) => {
              Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
              if (response && response.data.id) {
                this.$router.push({
                  name: 'CommissionCard',
                  params: { id: response.data.id, action: 'edit', type: this.type },
                });
              }
            })
            .catch(() => {
              Constants.alert.fire('Сохранение', Constants.commonError, 'error');
            });
      },
      close() {
        this.$router.push({ name: 'Commissions', params: { type: this.type } });
      },
      fileUploaded(e) {
        this.item.files.push(e.data);
      },
      removeFile(e) {
        var file = this.item.files.find((x) => x.id == e.id);
        var index = this.item.files.indexOf(file);
        if (index !== -1) {
          this.item.files.splice(index, 1);
        }
      },
      processEvents(arr) {
        if (arr && arr.length) {
          if (this.isRG || this.isSC) {
            this.eventsFull = arr.sort((a, b) => {
              return moment(b.eventLastDate) - moment(a.eventLastDate);
            });
          } else {
            this.eventsFull = arr
              .filter(
                (i) =>
                  +i.eventTypeId === TYPE_EVENT_ID_MEETINGS_MPK || +i.eventTypeId === TYPE_EVENT_ID_MEETINGS_CO_CHAIRS,
              )
              .sort((a, b) => {
                return moment(b.eventLastDate) - moment(a.eventLastDate);
              });
          }
          this.events = this.eventsFull.slice(0, 4);
        }
      },
      editRg(item) {
        const typeKey = COMMISSION_TYPE_IDS[item.type] || 'rg';
        this.$router.push({
          name: 'CommissionCard',
          params: { id: item.id, type: typeKey, action: this.canEdit ? 'edit' : 'view' },
        });
      },
      deleteRg(id) {
        Constants.alert.fire(Constants.confirmOptions.delete).then((res) => {
          if (res.isConfirmed) {
            API.delete(id)
              .then(() => {
                Constants.alert.fire('Удаление', 'Запись удалена', 'success');
                this.loadPageRg();
              })
              .catch((error) => {
                Constants.alert.fire(
                  'Удаление',
                  error.response && error.response.data
                    ? error.response.data
                    : 'Запись не удалена. Она используется в других реестрах.',
                  'error',
                );
              });
          }
        });
      },

      showEvent() {
        this.showFullListEvent = !this.showFullListEvent;
      },

      createEvent() {
        this.isEventCreating = true;
        if (!this.item.countryId || this.item.countryId <= 0) {
          Constants.alert.fire('Ошибка', 'Сначала выберите страну', 'error');
          return;
        }
        this.showEventModal = true;
        this.eventModalNn++;
      },

      closeEventModal() {
        this.showEventModal = false;
        this.isEventCreating = false;
      },

      onEventSaved(eventData) {
        if (eventData && eventData.id) {
          this.eventsFull.unshift(eventData);
          this.events = this.eventsFull.slice(0, 4);
        }
        this.closeEventModal();
      },

      editEvent(id) {
        this.$router.push({
          path: `/mpk/events/edit/${id}`,
          query: {
            commissionId: this.id,
            commissionType: this.type,
          },
        });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        item: {
          name: { required },
          countryId: { required, selectValidator },
          statusId: { required, selectValidator },
          parentId: {
            required: requiredIf(function () {
              return this.isRG || this.isSC;
            }),
            selectIfRGValidator: selectIfRGValidator(this.isRG || this.isSC),
          },
        },
      };
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/theme/default/title.scss';
  @import '@/modules/crossCuttingTask/styles/coll.scss';

  .form-card {
    margin-top: 40px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 0 16px 0 rgba(0, 0, 0, 0.1);
    padding: 24px 16px 0;
    flex-wrap: wrap;
    display: flex;
    margin-bottom: 50px;

    &__country {
      display: flex;
      align-items: center;

      &-img {
        width: 40px;
        height: 24px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        margin-right: 8px;
      }
    }

    &__parent {
      letter-spacing: -0.4px;
      font: $fira-20;
    }

    &__inner-card {
      width: 100%;
      padding-top: 24px;
      border-top: 1px dashed $grey;
      display: flex;
      flex-wrap: wrap;
    }

    @media (max-width: $laptop) {
      margin-top: 24px;
      padding: 20px 8px 8px;
      margin-bottom: 0;

      &__inner-card {
        padding-top: 16px;
      }
    }
  }

  .commision-mpk {
    &__container {
      margin-top: 40px;
    }

    @media (max-width: $laptop) {
      &__container {
        margin-top: 24px;
      }
    }
  }
  .card-info {
    &__row {
      flex-wrap: wrap;
      .control-label,
      .title {
        font-family: 'Fira Sans', sans-serif;
        font-size: 14px;
        line-height: 160%;
      }
      .title {
        font-weight: 500;
        color: #343c44;
      }
      .control-label {
        font-weight: 400;
        color: #231f20;
      }
      .title,
      .container-block {
        width: 100%;
      }
      .container-block {
        display: flex;
        justify-content: space-between;
        margin-bottom: 16px;
      }
      &.btns {
        justify-content: flex-end;
        button {
          &:not(:last-of-type) {
            margin-right: 16px;
          }
        }
      }
    }
  }

  .create-event--button {
    margin-bottom: 24px;
  }

  @media (max-width: 768px) {
    .card-info__row .container-block {
      flex-wrap: wrap;
    }
  }
  @media (max-width: 767px) {
    .card-info__row.btns button {
      width: 100%;
      &:not(:last-of-type) {
        margin-right: 0;
        margin-bottom: 16px;
      }
    }
    .create-event--button {
      margin-bottom: 16px;
    }
  }

  .imagePreviewWrapper {
    width: 48px;
    height: 24px;
    display: inline-block;
    float: left;
    cursor: pointer;
    background-size: cover;
    background-position: center center;
  }

  .structure-row {
    $class: &;

    &#{$class}_level-0 {
      background-color: $light-grey;

      td:first-child {
        padding-left: 16px;
        font-weight: 600;
      }
    }

    &#{$class}_level-1 {
      background-color: transparent;

      td:first-child {
        padding-left: 40px;
      }
    }
  }
</style>
